import * as React from "react";
import {FixedBreakType} from "@/shared/timrTypes";

function modeOptions() {
	return [
		{value: FixedBreakType.NONE, label: messages["breakModel.fixedBreakType.NONE"]},
		{value: FixedBreakType.ALL_DAYS_EQUAL, label: messages["breakModel.fixedBreakType.ALL_DAYS_EQUAL"]},
		{value: FixedBreakType.PER_DAY, label: messages["breakModel.fixedBreakType.PER_DAY"]}
	];
}

interface FixedBreakTypeSelectorProps {
	/** Currently selected fixed-break mode. */
	value: FixedBreakType;
	/** Called when the user switches between none, all-days-equal, and per-day modes. */
	onChange: (value: FixedBreakType) => void;
}

/**
 * Renders the fixed-break mode selector as a Bootstrap button group.
 *
 * This keeps the mode choice visually aligned with the surrounding legacy dialog while
 * still using React state updates for the fixed-break configuration.
 */
export function FixedBreakTypeSelector({value, onChange}: Readonly<FixedBreakTypeSelectorProps>) {
	return (
		<div className="btn-group fixed-break-type-selector" aria-label={messages["breakModel.fixedBreaks"]}>
			{modeOptions().map(option => (
				<button
					key={option.value}
					type="button"
					className={`btn ${option.value === value ? "btn-primary" : "btn-default"}`}
					aria-pressed={option.value === value}
					onClick={() => onChange(option.value)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
}
